<div class="p-4">
  <div class="flex items-center gap-2.5 mb-4">
    <label for="channel-select" class="text-sm font-semibold text-neutral-500 dark:text-neutral-400">
      Canal de venda:
    </label>
    <select
      id="channel-select"
      [(ngModel)]="selectedChannelId"
      (ngModelChange)="onChannelChange()"
      [disabled]="refreshing"
      class="control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white">
      @for (channel of channels; track channel.id) {
        <option [ngValue]="channel.id">{{ channel.label }}</option>
      }
    </select>
  </div>

  @if (error) {
    <app-alert type="danger">{{ error }}</app-alert>
  }

  @if (initialLoading) {
    <app-loading size="large" />
  }

  @if (!initialLoading && parsed) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento hoje"
          subtitle="Total acumulado hoje de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.today.value)"
          icon="dollar-sign"
          color="success" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>

      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento ontem"
          subtitle="Total acumulado ontem de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.yesterdaySameHour.value)"
          icon="dollar-sign"
          color="info" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>

      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento semana anterior"
          subtitle="Total acumulado na semana anterior de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.lastWeekFullDay.value)"
          icon="dollar-sign"
          color="primary" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>
    </div>
  }
</div>
